import { createHttpMethod } from './http/http-client';
export class ApiEndpointClient {
    http;
    prefix;
    constructor(http, prefix) {
        this.http = http;
        this.prefix = prefix;
    }
    get = createHttpMethod((path, options) => this.http.get(`${this.prefix}${path}`, options));
    post = createHttpMethod((path, options) => this.http.post(`${this.prefix}${path}`, options));
    put = createHttpMethod((path, options) => this.http.put(`${this.prefix}${path}`, options));
    patch = createHttpMethod((path, options) => this.http.patch(`${this.prefix}${path}`, options));
    delete = createHttpMethod((path, options) => this.http.delete(`${this.prefix}${path}`, options));
    postFile(path, file, options) {
        return this.http.postFile(`${this.prefix}${path}`, file, options);
    }
}
